// V3 Farms
import {
  DeserializedFarm,
  FarmV3DataWithPriceAndUserInfo,
  FarmWithStakedValue,
  filterFarmsByQuery,
  supportedChainIdV2,
  supportedChainIdV3,
} from '@pancakeswap/farms'
import { useIntersectionObserver } from '@pancakeswap/hooks'
import { useTranslation } from '@pancakeswap/localization'
import { ChainId } from '@pancakeswap/chains'
import {
  ArrowForwardIcon,
  Box,
  Button,
  Flex,
  FlexLayout,
  Heading,
  Image,
  Link,
  Loading,
  NextLinkFromReactRouter,
  OptionProps,
  PageHeader,
  SearchInput,
  Select,
  Text,
  Toggle,
  ToggleView,
  useMatchBreakpoints,
} from '@pancakeswap/uikit'
import { FarmWidget } from '@pancakeswap/widgets-internal'
import BigNumber from 'bignumber.js'
import Page from 'components/Layout/Page'
import { useActiveChainId } from 'hooks/useActiveChainId'
import orderBy from 'lodash/orderBy'
import { useRouter } from 'next/router'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useFarms, usePollFarmsWithUserData } from 'state/farms/hooks'
import { useBBCPrice } from 'hooks/useCakePrice'
import { useFarmsV3WithPositionsAndBooster } from 'state/farmsV3/hooks'
import { useCakeVaultUserData } from 'state/pools/hooks'
import { ViewMode } from 'state/user/actions'
import { useUserFarmStakedOnly, useUserFarmsViewMode } from 'state/user/hooks'
import { styled } from 'styled-components'
import { getFarmApr } from 'utils/apr'
import { V3_MIGRATION_SUPPORTED_CHAINS } from 'config/constants/supportChains'
import { getStakedFarms } from 'views/Farms/utils/getStakedFarms'
import { V3SubgraphHealthIndicator } from 'components/SubgraphHealthIndicator'
import { useAccount } from 'wagmi'
import { BIG_ONE, BIG_ZERO } from '@pancakeswap/utils/bigNumber'
import EPageHeader from 'components/EPageHeader'
import { useGsapEntrance } from 'hooks/useGsapEntrance'
import { CardGridSkeleton } from 'components/Skeletons'
import Table from './components/FarmTable/FarmTable'
import { FarmTypesFilter } from './components/FarmTypesFilter'
import { BCakeBoosterCard } from './components/YieldBooster/components/bCakeV3/BCakeBoosterCard'
import { FarmsV3Context } from './context'
import FarmCard from './components/FarmCard/FarmCard'
import { FarmV3Card } from './components/FarmCard/V3/FarmV3Card'
import { getDisplayApr } from './components/getDisplayApr'


const PageStyled = styled(Page)`
  padding: 8px;
  color: ${({ theme }) => theme.colors.text};
  background: transparent;
`

const ControlContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  position: relative;

  justify-content: space-between;
  flex-direction: column;
  margin-bottom: 32px;

  gap: 8px;

  ${({ theme }) => theme.mediaQueries.sm} {
    flex-direction: row;
    flex-wrap: wrap;
    padding: 16px 0;
    margin-bottom: 0;
  }
`

const FarmFlexWrapper = styled(Flex)`
  flex-wrap: wrap;
  ${({ theme }) => theme.mediaQueries.md} {
    flex-wrap: nowrap;
  }
`
const FarmH1 = styled(Heading)`
  font-size: 32px;
  margin-bottom: 8px;
  ${({ theme }) => theme.mediaQueries.sm} {
    font-size: 64px;
    margin-bottom: 24px;
  }
`
const FarmH2 = styled(Heading)`
  font-size: 16px;
  margin-bottom: 8px;
  ${({ theme }) => theme.mediaQueries.sm} {
    font-size: 24px;
    margin-bottom: 18px;
  }
`

const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  // margin-left: 10px;

  // ${Text} {
  //   margin-left: 8px;
  // }
`

const LabelWrapper = styled.div`
  > ${Text} {
    font-size: 12px;
  }
`

const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 8px 0px;

  ${({ theme }) => theme.mediaQueries.sm} {
    width: auto;
    padding: 0;
  }
`

const ViewControls = styled.div`
  flex-wrap: wrap;
  gap: 16px;
  justify-content: space-between;
  display: flex;
  align-items: center;
  width: 100%;

  > div {
    // padding: 8px 0px;
  }

  ${({ theme }) => theme.mediaQueries.sm} {
    justify-content: flex-start;
    width: auto;

    > div {
      // padding: 0;
    }
  }
`

const StyledImage = styled(Image)`
  margin-left: auto;
  margin-right: auto;
  margin-top: 58px;
`

const FinishedTextContainer = styled(Flex)`
  flex-direction: column;
  ${({ theme }) => theme.mediaQueries.md} {
    flex-direction: row;
  }
`

const FinishedTextLink = styled(Link)`
  font-weight: 400;
  white-space: nowrap;
  text-decoration: underline;
`

const CardLayout = styled(FlexLayout)`
  // margin-left: -26px;
  // margin-right: -26px;
  ${({theme}) => theme.mediaQueries.md} {
    margin: 0;
}
`

const Divider = styled(Text)`
  display: flex;
  width: 100%;
  max-width: 100%;
  align-items: center;
  gap: 8px;
  &::after {
    content: '';
    height: 1px;
    flex: 1;
    border-top: 1px solid ${({ theme }) => theme.colors.cardBorder};
  }
`

const StyledSelect = styled(Select)`
  background: transparent;
  border-radius: 24px;
  border: 1px solid ${({ theme }) => theme.colors.cardBorder};
`

const NUMBER_OF_FARMS_VISIBLE = 12

export interface V3FarmWithoutStakedValue extends FarmV3DataWithPriceAndUserInfo {
  version: 3
}

export interface V3Farm extends V3FarmWithoutStakedValue {
  version: 3
}

export interface V2FarmWithoutStakedValue extends DeserializedFarm {
  version: 2
}

export interface V2Farm extends FarmWithStakedValue {
  version: 2
}

type V2AndV3Farms = Array<V3FarmWithoutStakedValue | V2FarmWithoutStakedValue>

export type V2StakeValueAndV3Farm = V3Farm | V2Farm

const Farms: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { pathname, query: urlQuery } = useRouter()
  const farmsTitle = pathname.includes('prc20farms') ? 'PRC20 Farms' : 'Farms'
  const mockApr = Boolean(urlQuery.mockApr)
  const { t } = useTranslation()
  const { chainId } = useActiveChainId()
  const { data: farmsV2, userDataLoaded: v2UserDataLoaded, poolLength: v2PoolLength, regularCakePerBlock } = useFarms()
  const {
    farmsWithPositions: farmsV3,
    poolLength: v3PoolLength,
    isLoading,
    userDataLoaded: v3UserDataLoaded,
  } = useFarmsV3WithPositionsAndBooster({ mockApr })

  const { isDesktop, isMobile } = useMatchBreakpoints()

  // FIXME: temporary sort sable v2 farm in front of v3 farms
  const farmsLP: V2AndV3Farms = useMemo(() => {
    const farms: V2AndV3Farms = [
      ...farmsV3.map((f) => ({ ...f, version: 3 } as V3FarmWithoutStakedValue)),
      ...farmsV2.map((f) => ({ ...f, version: 2 } as V2FarmWithoutStakedValue)),
    ]
    if (chainId !== ChainId.PULSE) {
      return farms
    }
    const sableFarm = farms.find((f) => f.version === 2 && f.pid === 167)
    const v3TargetFarm = farms.find((f) => f.version === 3 && f.pid === 60)
    if (!sableFarm || !v3TargetFarm) {
      return farms
    }
    const sableFarmIndex = farms.indexOf(sableFarm)
    const targetIndex = farms.indexOf(v3TargetFarm)
    return [
      ...farms.slice(0, targetIndex + 1),
      sableFarm,
      ...farms.slice(targetIndex + 1, sableFarmIndex),
      ...farms.slice(sableFarmIndex + 1),
    ]
  }, [farmsV2, farmsV3, chainId])

  // if (pathname.includes('prc20farms?chain=eth')) {
  //   window.location.href = 'https://v2.9inch.io/prc20farms?chain=pulse'
  // }

  const inactive = [
    '0x37515F5F2bb8a45Ae7CceF8653762a28cc8d4e3E',
    '0x330a3a0a05f8F3Cc7Bb1372e98EcaCa75fcbDc69',
    '0x9F7578Fef8c1Fba986d2db83e4b1Fa5F1ECb7324',
    '0x828cc8423fc97817CaD78C8bFBbA26923444dF60',
    '0x329958477eaa4BFC9A036BA620a7E71dE75d44D4',
    '0xF7bf31eed070538A5Ad491F7c0E57Bd717740575',
    '0xf3499Cd797367DB82C230D9AcBCB370f8d38D78A',
    "0xEAF45dEA447e882BbDa8a12CAD0d90DadC21d9A5",
    "0xD333868dcba6F95dBFaFC1d86198A87f47C4bCce",
    "0x9C7C1F0D7bA90817F9E8B18CaA83bBBB0ddA0C51",
    "0xD440CA5d80BD9771b0080AeD44F702cB68010a7b",
    "0x2C4BAdF3C89deDEfE5c03e42009D25d7E4113012",
    "0x362D4073eb7583D6dffa15029918BCd531Faa0bC",
    "0xd243447C3E5945535c81bfc03F8DC4363919C463",
    "0xecd0a81936663A83D28c8CaD5d04b2feae519e5f",
    "0xB617BF4667F54AB82fC91c2d49a0A223E12C0E6b",
    "0x9436CaCb51D468b628300CC79bA057D347AFF4E6",
    "0xBc38cCDb8c84f6FddC74e43aB3B3EC82c1902C59",
    "0x913e5c7198dbFB069AfCC38F1682a69C4b8bC9Ed",
    "0x80721b57076970170B41DCbE151521184eC3a86c",
    "0x28EB1804401B8d84751d6EB77010E8fA1B377E25",
    "0x03f4232B6a6e4d705424679f3b0f7304cdBE7d25",
    "0x95d64bF395BecEe313ab3498f1F13D77a5DEe2dd",
    "0x40f18C90b85B8Bb3201d2F0f61AaD410A4E0B7D8",
    "0x604958ae2C28DA20B593ca132E3e5b16e3fD49c5",
    "0x688a56B8DE7D705Dddf0fe21F35b467081bb45FD",
    "0xE1b221AF0F956631cFB99bae7c31a4e07dA9B5be"
  ]

  const prc20Farms = [
    '0xd7b70d726cb370Ac96EB6912Db1F57A8Df73267F',
    '0x8356eDc1d60B0EdE626BC52980e708A604b0E861',
    '0xbD1d593A038dA65F247C8b3d5C445dE9a031DB53',
    '0xd7E98780C10c9c716A87A7f76E76cB1d49556dA1',
    '0x994E575563F8204D2CcC022e91dD91138B0506C2',
    "0x3FDEe45d0F9a055c175E6cB986AC07E5BAD9Befa",
    "0x04159006f117Bc9777F5896B426956b9eE5A4540",
    "0x73004b74ADaeEBdf163f212B77463380f6AD8c44",
    "0xe55B34090743Da5A72d3762d28Fe6341fb335f73"
  ]

  const CATEGORIES = {
    "Core Coins": [
      "9INCH-PLS",
      "9INCH-BBC",
      "9INCH-DAI",
      "9INCH-USDC",
      "9INCH-USDT",
      "9INCH-PLSX",
      "PLS-PLSX",
      "BBC-INC",
      "9INCH-HEX",
      "9INCH-W9INCH",
    ],
    "PRC20": [
      "pDAI-pWBTC",
      "PLS-pDAI",
      "PLS-pWBTC",
      "DAI-pDAI",
      "HEX-eHEX",
      "PLS-PAXG",
      "PLS-MOG",
      "PLS-PEPE",
    ],
    "Memecoins": [
      "PLS-BEAR",
      "PLS-ATROPA",
      "PLS-BRO",
      "BBC-BRO",
    ],
    "SOLID Index": [
      "PLS-SOLIDX",
      "9INCH-SOLIDX",
      "BBC-SOLIDX",
      "PLS-AXIS",
      "BBC-AXIS",
      "PLS-NOPE",
      "9INCH-NOPE",
      "PLS-FIRE",
      "9INCH-FIRE",
    ]
  }

  // if (pathname.includes('prc20')) {
  //   farmsLP = farmsLP.filter((farm) => prc20Farms.includes(farm.lpAddress))
  // } else {
  //   farmsLP = farmsLP.filter((farm) => !prc20Farms.includes(farm.lpAddress))
  for (let i = 0; i < farmsLP.length; i++) {
    if (inactive.includes(farmsLP[i].lpAddress)) {
      farmsLP[i].multiplier = '0X'
    }
    const symbol0 = farmsLP[i].lpSymbol.replace(" LP", "")
    const symbol1 = symbol0.split('-').reverse().join("-")
    farmsLP[i].category = Object.entries(CATEGORIES).find(([, lps]: [c: string, lps: string[]]) => {
      return (lps.includes(symbol0) || lps.includes(symbol1))
    })?.[0]
  }
  // }

  const cakePrice = useBBCPrice()


  const [_query, setQuery] = useState('')
  const normalizedUrlSearch = useMemo(() => (typeof urlQuery?.search === 'string' ? urlQuery.search : ''), [urlQuery])
  const query = normalizedUrlSearch && !_query ? normalizedUrlSearch : _query

  const [viewMode, setViewMode] = useUserFarmsViewMode()
  const { address: account } = useAccount()
  const [sortOption, setSortOption] = useState('hot')
  const { observerRef, isIntersecting } = useIntersectionObserver()
  const chosenFarmsLength = useRef(0)

  const isArchived = pathname.includes('archived')
  const isInactive = pathname.includes('history')
  const isActive = !isInactive && !isArchived

  useCakeVaultUserData()

  usePollFarmsWithUserData()

  // Users with no wallet connected should see 0 as Earned amount
  // Connected users should see loading indicator until first userData has loaded
  const userDataReady =
    !account ||
    (!!account &&
      (chainId && supportedChainIdV2.includes(chainId) ? v2UserDataLoaded : true) &&
      (chainId && supportedChainIdV3.includes(chainId) ? v3UserDataLoaded : true))

  const [stakedOnly, setStakedOnly] = useUserFarmStakedOnly(isActive)
  const [v3FarmOnly, setV3FarmOnly] = useState(false)
  const [v2FarmOnly, setV2FarmOnly] = useState(false)
  const [boostedOnly, setBoostedOnly] = useState(false)
  const [stableSwapOnly, setStableSwapOnly] = useState(false)
  const [farmTypesEnableCount, setFarmTypesEnableCount] = useState(0)


  const activeFarms = farmsLP.filter(
    (farm) =>
      farm.pid !== 0 &&
      farm.multiplier !== '0X'
    // (farm.version === 3 ? !v3PoolLength || v3PoolLength >= farm.pid : !v2PoolLength || v2PoolLength > farm.pid),
  )


  const inactiveFarms = farmsLP.filter((farm) => farm.pid !== 0 && farm.multiplier === '0X')

  const archivedFarms = farmsLP

  const stakedOnlyFarms = useMemo(() => getStakedFarms(activeFarms), [activeFarms])

  const stakedInactiveFarms = useMemo(() => getStakedFarms(inactiveFarms), [inactiveFarms])

  const stakedArchivedFarms = useMemo(() => getStakedFarms(archivedFarms), [archivedFarms])

  const farmsList = useCallback(
    (farmsToDisplay: V2AndV3Farms): V2StakeValueAndV3Farm[] => {
      const farmsToDisplayWithAPR: any = farmsToDisplay.map((farm) => {
        if (farm.version === 3) {
          return farm
        }

        if (!farm.quoteTokenAmountTotal || !farm.quoteTokenPriceBusd) {
          return farm
        }
        const totalLiquidityFromLp = new BigNumber(farm?.lpTotalInQuoteToken ?? 0).times(farm.quoteTokenPriceBusd)
        // Mock 1$ tvl if the farm doesn't have lp staked
        const totalLiquidity = totalLiquidityFromLp.eq(BIG_ZERO) && mockApr ? BIG_ONE : totalLiquidityFromLp
        const { cakeRewardsApr, lpRewardsApr } =
          isActive && chainId
            ? getFarmApr(
              chainId,
              new BigNumber(farm?.poolWeight ?? 0),
              cakePrice,
              totalLiquidity,
              farm.lpAddress,
              regularCakePerBlock,
            )
            : { cakeRewardsApr: 0, lpRewardsApr: 0 }

        return { ...farm, apr: cakeRewardsApr, lpRewardsApr, liquidity: totalLiquidity }
      })

      return filterFarmsByQuery(farmsToDisplayWithAPR, query)
    },
    [query, isActive, chainId, cakePrice, regularCakePerBlock, mockApr],
  )

  const handleChangeQuery = (event: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(event.target.value)
  }

  const [numberOfFarmsVisible, setNumberOfFarmsVisible] = useState(NUMBER_OF_FARMS_VISIBLE)

  const chosenFarms = useMemo(() => {
    let chosenFs: V2StakeValueAndV3Farm[] = []
    if (isActive) {
      chosenFs = stakedOnly ? farmsList(stakedOnlyFarms) : farmsList(activeFarms)
    }
    if (isInactive) {
      chosenFs = stakedOnly ? farmsList(stakedInactiveFarms) : farmsList(inactiveFarms)
    }
    if (isArchived) {
      chosenFs = stakedOnly ? farmsList(stakedArchivedFarms) : farmsList(archivedFarms)
    }

    if (v3FarmOnly || v2FarmOnly || boostedOnly || stableSwapOnly) {
      const filterFarmsWithTypes = chosenFs.filter(
        (farm) =>
          (v3FarmOnly && farm.version === 3) ||
          (v2FarmOnly && farm.version === 2) ||
          (boostedOnly && farm.boosted && farm.version === 3) ||
          (stableSwapOnly && farm.version === 2 && farm.isStable),
      )

      const stakedFilterFarmsWithTypes = getStakedFarms(filterFarmsWithTypes)

      chosenFs = stakedOnly ? farmsList(stakedFilterFarmsWithTypes) : farmsList(filterFarmsWithTypes)
    }

    return chosenFs
  }, [
    isActive,
    isInactive,
    isArchived,
    stakedOnly,
    farmsList,
    stakedOnlyFarms,
    activeFarms,
    stakedInactiveFarms,
    inactiveFarms,
    stakedArchivedFarms,
    archivedFarms,
    boostedOnly,
    stableSwapOnly,
    v3FarmOnly,
    v2FarmOnly,
  ])

  const orderedCategories = useMemo(() => {
    const categories = chosenFarms.reduce((result, farm) => {
      let farmValue: number = 0
      if (sortOption === 'apr') {
        farmValue = farm.version === 3 ? Number(farm.cakeApr) : farm.apr ?? 0
      } else if (sortOption === 'multiplier') {
        farmValue = farm.multiplier ? Number(farm.multiplier.slice(0, -1)) : 0
      } else if (sortOption === 'earned') {
        if (farm.version === 2) {
          farmValue = farm.userData ? Number(farm.userData.earnings) : 0
        } else {
          const totalEarned = Object.values(farm.pendingCakeByTokenIds)
            .reduce((a, b) => a + b, 0n)
          farmValue = account ? Number(totalEarned) : 0
        }
      } else if (sortOption === 'liquidity') {
        farmValue = farm.version === 3 ? Number(farm.activeTvlUSD) : Number(farm.liquidity)
      } else if (sortOption === 'latest') {
        farmValue = Number(farm.pid)
      }
      return {
        ...result,
        [farm.category]: (result[farm.category] ?? 0) + farmValue
      }
    }, {})
    return orderBy(Object.entries(categories), ([, value]) => value, 'desc').map(([category]) => category)
  }, [chosenFarms, sortOption, account])

  const chosenFarmsMemoized = useMemo(() => {
    const sortFarms = (farms: V2StakeValueAndV3Farm[]): V2StakeValueAndV3Farm[] => {
      switch (sortOption) {
        case 'apr':
          return orderBy(farms, (farm) => (farm.version === 3 ? Number(farm.cakeApr) : farm.apr ?? 0), 'desc')
        case 'multiplier':
          return orderBy(farms, (farm) => (farm.multiplier ? Number(farm.multiplier.slice(0, -1)) : 0), 'desc')
        case 'earned':
          return orderBy(
            farms,
            (farm) => {
              if (farm.version === 2) {
                return farm.userData ? Number(farm.userData.earnings) : 0
              }
              const totalEarned = Object.values(farm.pendingCakeByTokenIds)
                .reduce((a, b) => a + b, 0n)
                .toString()
              return account ? totalEarned : 0
            },
            'desc',
          )
        case 'liquidity':
          return orderBy(
            farms,
            (farm) => {
              if (farm.version === 3) {
                return Number(farm.activeTvlUSD)
              }
              return Number(farm.liquidity)
            },
            'desc',
          )
        case 'latest':
          return orderBy(
            orderBy(farms, (farm) => Number(farm.pid), 'desc'),
            ['version'],
            'desc',
          )
        default:
          return farms
      }
    }

    return sortFarms(chosenFarms) // .slice(0, numberOfFarmsVisible)
  }, [chosenFarms, sortOption, account])

  // chosenFarmsLength.current = chosenFarmsMemoized.length

  useEffect(() => {
    if (isIntersecting) {
      setNumberOfFarmsVisible((farmsCurrentlyVisible) => {
        if (farmsCurrentlyVisible <= chosenFarmsLength.current) {
          return farmsCurrentlyVisible + NUMBER_OF_FARMS_VISIBLE
        }
        return farmsCurrentlyVisible
      })
    }
  }, [isIntersecting])

  const handleSortOptionChange = (option: OptionProps): void => {
    setSortOption(option.value)
  }

  const providerValue = useMemo(() => ({ chosenFarmsMemoized }), [chosenFarmsMemoized])
  const entranceRef = useGsapEntrance<HTMLDivElement>()

  return (
    <FarmsV3Context.Provider value={providerValue}>
      <PageStyled ref={entranceRef}>
        <EPageHeader pageName={farmsTitle} align="left" />
        <ControlContainer data-anim>
          <ViewControls>
            {
              isDesktop &&
              <ToggleView idPrefix="clickFarm" viewMode={viewMode} onToggle={setViewMode} />
            }
            <FarmWidget.FarmTabButtons hasStakeInFinishedFarms={stakedInactiveFarms.length > 0} />
            {/* <Flex mt="20px" ml="16px">
              <FarmTypesFilter
                v3FarmOnly={v3FarmOnly}
                handleSetV3FarmOnly={setV3FarmOnly}
                v2FarmOnly={v2FarmOnly}
                handleSetV2FarmOnly={setV2FarmOnly}
                boostedOnly={boostedOnly}
                handleSetBoostedOnly={setBoostedOnly}
                stableSwapOnly={stableSwapOnly}
                handleSetStableSwapOnly={setStableSwapOnly}
                farmTypesEnableCount={farmTypesEnableCount}
                handleSetFarmTypesEnableCount={setFarmTypesEnableCount}
              />
              <ToggleWrapper>
                <Toggle
                  id="staked-only-farms"
                  checked={stakedOnly}
                  onChange={() => setStakedOnly(!stakedOnly)}
                  scale="sm"
                />
                <Text> {t('Staked only')}</Text>
              </ToggleWrapper>
            </Flex> */}
            {
              isDesktop &&
              <Text fontSize="14px">
                {t("Stake LP tokens and earn BBC")}
              </Text>
            }
          </ViewControls>
          <ViewControls>
            <ToggleWrapper>
              <Toggle
                id="staked-only-farms"
                checked={stakedOnly}
                onChange={() => setStakedOnly(!stakedOnly)}
                scale="sm"
              />
              <Text fontSize={14}> {stakedOnly ? t('Staked only') : t('All farms')}</Text>
            </ToggleWrapper>
            <FilterContainer>
              <StyledSelect
                options={[
                  {
                    label: t('APR'),
                    value: 'apr',
                  },
                  {
                    label: t('Earned'),
                    value: 'earned',
                  },
                  {
                    label: t('Liquidity'),
                    value: 'liquidity',
                  },
                  {
                    label: t('Latest'),
                    value: 'latest',
                  },
                ]}
                onOptionChange={handleSortOptionChange}
              />
            </FilterContainer>
            <SearchInput initialValue={normalizedUrlSearch} onChange={handleChangeQuery} placeholder="Search Farms" />
          </ViewControls>
          {/* <FilterContainer>
            <LabelWrapper>
              <Text textTransform="uppercase" color="textSubtle" fontSize="12px" bold>
                {t('Sort by')}
              </Text>
              <Select
                options={[
                  {
                    label: t('APR'),
                    value: 'apr',
                  },
                  {
                    label: t('Earned'),
                    value: 'earned',
                  },
                  {
                    label: t('Liquidity'),
                    value: 'liquidity',
                  },
                  {
                    label: t('Latest'),
                    value: 'latest',
                  },
                ]}
                onOptionChange={handleSortOptionChange}
              />
            </LabelWrapper>
            <LabelWrapper style={{ marginLeft: 16, paddingTop: 14 }}>
              <Text textTransform="uppercase" color="textSubtle" fontSize="12px" bold>
                {t('Search')}
              </Text>
              <SearchInput initialValue={normalizedUrlSearch} onChange={handleChangeQuery} placeholder="Search Farms" />
            </LabelWrapper>
          </FilterContainer> */}
        </ControlContainer>
        {isInactive && (
          <Box mb="32px">
            {chainId === ChainId.BSC && (
              <FinishedTextContainer>
                <Text fontSize={['16px', null, '20px']} color="failure" pr="4px">
                  {t("Don't see the farm you are staking?")}
                </Text>
                <Flex>
                  <FinishedTextLink
                    external
                    color="failure"
                    fontSize={['16px', null, '20px']}
                    href="https://v1-farms.pre-prod.v3-cbr.pages.dev/farms/history"
                  >
                    {t('check out v1 farms')}.
                  </FinishedTextLink>
                </Flex>
              </FinishedTextContainer>
            )}
            {chainId && V3_MIGRATION_SUPPORTED_CHAINS.includes(chainId) && (
              <FinishedTextContainer>
                <Text fontSize={['16px', null, '20px']} color="failure" pr="4px">
                  {t('Unstaking from v2 farm?')}
                </Text>
                <Flex>
                  <FinishedTextLink external color="failure" fontSize={['16px', null, '20px']} href="/migration">
                    {t('Migrate to v3 here')}.
                  </FinishedTextLink>
                </Flex>
              </FinishedTextContainer>
            )}
          </Box>
        )}

        {isLoading && <CardGridSkeleton cards={6} />}

        {!isLoading && // FarmV3 initial data will be slower, wait for it loads for now to prevent showing the v2 farm from config and then v3 pop up later
          (viewMode === ViewMode.TABLE && isDesktop ? (
            <Table farms={chosenFarms} cakePrice={cakePrice} userDataReady={userDataReady} />
          ) : (
            <CardLayout>
              {
                orderedCategories.map(category => {
                  const categorizedFarms = chosenFarmsMemoized?.filter(farm => farm.category===category)
                  if (categorizedFarms?.length) {
                    return <>
                      <Divider fontSize={32} color="text">
                        {category}
                      </Divider>
                      {
                        categorizedFarms?.map((farm) => {
                          if (farm.version === 2) {
                            return <FarmCard
                              key={`${farm.pid}-${farm.version}`}
                              farm={farm}
                              displayApr={getDisplayApr(farm.apr, farm.lpRewardsApr)}
                              cakePrice={cakePrice}
                              account={account}
                              removed={false}
                            />
                          }
          
                          return (
                            <FarmV3Card
                              key={`${farm.pid}-${farm.version}`}
                              farm={farm}
                              cakePrice={cakePrice}
                              account={account}
                              removed={false}
                            />
                          )
                        })
                      }
                    </>
                  }
                  return null
                })
              }
            </CardLayout>
          ))}
        {account && !v2UserDataLoaded && !v3UserDataLoaded && stakedOnly && (
          <Flex justifyContent="center">
            <Loading />
          </Flex>
        )}
        {chosenFarms.length > 0 && <div ref={observerRef} />}
        {/* <StyledImage src="/images/decorations/3dpan.png" alt="Pancake illustration" width={120} height={103} /> */}
        <V3SubgraphHealthIndicator />
      </PageStyled>
    </FarmsV3Context.Provider>
  )
}

export default Farms
